import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import Page from 'components/shared/Page';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import Input from 'components/UI/Input';
import { useStores } from 'stores/hooks/hooks';
import { Menubar as PrimeReactMenuBar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
import VpdThresholds from './VpdThresholds/VpdThresholds';

const StyledPrimeReactMenuBar = styled(PrimeReactMenuBar)`
`;

const ContentPanel = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  background: var(--surface-section);
  /* padding: 1rem; */
  z-index: 1;
  border: 0 none;
  color: #495057;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
`;

const TabViewContainer = styled.div`
  flex-direction: column;
  position: relative;
  display: flex;
  width: 100%;
  /* margin-top: 1rem; */
`;

const StyledInput = styled(Input)`
  background-color: ${(p) => p.theme.palette.background.default};
`;

export const TreeContainer = styled.div`
  height: calc(100vh - 106px);
  margin: 1rem;
  margin-right: 0;
  overflow: hidden;
`;

const enum ThresholdsTab {
  VpdThresholdsTab = 0,
}

const Thresholds: FC = observer(() => {
  const { t } = useTranslation('thresholds');
  const [activeTab, setActiveTab] = useState<ThresholdsTab>(
    ThresholdsTab.VpdThresholdsTab,
  );

  const handleTabChange = useCallback((tabId: ThresholdsTab) => {
    setActiveTab(tabId);
  }, []);

  const menuItems: MenuItem[] = useMemo(
    () => [
      {
        label: t('vpd'),
        icon: 'pi pi-fw pi-gauge',
        command: () => handleTabChange(ThresholdsTab.VpdThresholdsTab),
        className:
          activeTab === ThresholdsTab.VpdThresholdsTab ? 'p-highlight' : '',
      },
    ],
    [t, activeTab, handleTabChange],
  );

  // const handleSearchChange = useCallback(() => {
  //   // TODO: implement search for each tab
  //   // resellersStore.setGlobalFilter((event.target.value || '').trim());
  // }, []);

  const renderContent = () => {
    switch (activeTab) {
      case ThresholdsTab.VpdThresholdsTab:
        return <VpdThresholds />;
      default:
        return null;
    }
  };

  return (
    <Page>
      <TabViewContainer>
        <StyledPrimeReactMenuBar model={menuItems} />
        <ContentPanel>{renderContent()}</ContentPanel>
      </TabViewContainer>
    </Page>
  );
});

export default Thresholds;
